// extracted by mini-css-extract-plugin
export default {"modalTitle":"SharePopup_modalTitle__-YYyg","closeModalButton":"SharePopup_closeModalButton__Ii8Uz","buttonSection":"SharePopup_buttonSection__qtNw1"};